import { isNumber } from './isType';

/**
 * converte diferentes formatos para boolean
 *
 * @category Typing
 */
export type BooleanInput = string | boolean | null | undefined;

/**
 * Força um valor (normalmente uma string) para boolean.
 * Normalmente utilizado para converter valores recebidos de
 *
 * @Inputs dos componentes para boolean.
 *
 * @category Typing
 */
export const enforceBoolean = (value: unknown): boolean => value != null && `${value}` !== 'false';

/**
 * Tipos possíveis de entrada para number
 *
 * @category Typing
 */
export type NumberInput = string | number | null | undefined;

/**
 * Tipos possíveis de entrada para string
 *
 * @category Typing
 */
export type StringInput = string | number | null | undefined;

/**
 * recebe um valor 'unknown' e força que o retorno seja um número
 *
 * @category Typing
 */
export const enforceNumber = (value: unknown, defaultValue = 0): number =>
  isNumber(value) ? Number(value) : defaultValue;
